import Reflux from "reflux";
import ActionUtil from "shared/util/ActionUtil";

import WebUtil from "quickmatch/util/WebUtil";

const Actions = Reflux.createActions({
	fetchMatches: ActionUtil.getAsyncTemplate(),
	vote: ActionUtil.getAsyncTemplate(),
	undo: ActionUtil.getAsyncTemplate(),

	showFlavors: {},
	selectFlavor: ActionUtil.getAsyncTemplate(),
	endFlavor: {},
	resetFlavors: ActionUtil.getAsyncTemplate(),
	showFlavorLikes: ActionUtil.getAsyncTemplate(),
	enableViewSwitching: {},
	openWIW: {},

	closeMutualLike: {},
	openLikesCapModal: {},
	incrementLikesCapModalViewCount: ActionUtil.getAsyncTemplate(),
});

ActionUtil.listen(Actions.fetchMatches, WebUtil.fetchMatches);
ActionUtil.listen(Actions.vote, WebUtil.vote);
ActionUtil.listen(Actions.undo, WebUtil.undo);
ActionUtil.listen(Actions.selectFlavor, WebUtil.selectFlavor);
ActionUtil.listen(Actions.resetFlavors, WebUtil.resetFlavors);
ActionUtil.listen(Actions.showFlavorLikes, WebUtil.showFlavorLikes);
ActionUtil.listen(Actions.incrementLikesCapModalViewCount, WebUtil.incrementLikesCapModalViewCount);

export default Actions;



// WEBPACK FOOTER //
// ./src/reflux/quickmatch/actions/Actions.js